<template>
  <v-card outlined>
    <v-card-text>
      <v-layout row wrap align-center justify-space-between fill-height>
        <v-flex xs12 sm3>
          <v-autocomplete v-model="selectedProduct" hide-no-data ref="productSearch" outlined
            :loading="productSearchLoading" prepend-inner-icon="search" rounded allow-overflow dense auto-select-first
            single-line :error-messages="error" :hide-details="error.length === 0" clearable eager id="productSearch"
            :items="Products" item-text="name" return-object :search-input.sync="phoneSearch"
            :label="$t('labels.searchProduct')">
            <template slot="item" slot-scope="{ item }">
              <span>{{ item.name }}</span>
              <v-spacer></v-spacer>
              <v-chip v-if="item.isFee" color="pink" label text-color="white">
                <v-icon left>
                  mdi-label
                </v-icon>
                School Fee
              </v-chip>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm3>
          <v-text-field @focus="$event.target.select()" label="Item Name" @keyup.enter="$refs.qty.focus" v-model="name"
            outlined dense hide-details autocomplete ref="itemName"></v-text-field>
        </v-flex>
        <v-flex xs12 sm1>
          <v-text-field class="centered-input" @focus="$event.target.select()" ref="qty" :disabled="disabledQty"
            label="Quantity" outlined dense type="number" hide-details @keyup.enter="$refs.unitPrice.focus"
            v-model="qty"></v-text-field>
        </v-flex>
        <v-flex xs12 sm2>
          <v-text-field class="right-input" @keyup.enter="submit" ref="unitPrice" @focus="$event.target.select()"
            label="Unit Price" v-model="price" outlined type="number" dense hide-details></v-text-field>
        </v-flex>
        <v-flex xs12 sm2>
          <v-text-field class="right-input" ref="extAmount" disabled outlined dense hide-details
            @focus="$event.target.select()" v-model="total" label="Ext Amount"></v-text-field>
        </v-flex>
        <v-flex d-flex xs12 sm1>
          <v-btn color="info" ref="addbutton" large @click="submit">
            add
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-dialog persistent v-model="dialog" max-width="400">
      <v-card :loading="loadingNumber">
        <ModelTitle title="Select Student" @close="closeDialog()" />
        <!-- getSelectedCustomer: {{ getSelectedCustomer }} -->
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12">
              <v-autocomplete dense autofocus hide-details :items="Students" clearable item-text="fullName"
                v-model="selectedStudent" return-object label="Select Student" outlined>
                <template slot="item" slot-scope="{ item }">
                  <span>{{ item.fullName }}</span>
                  <v-spacer></v-spacer>
                  <v-chip color="grey lighten-3">
                    <v-avatar left class="grey lighten-2">
                      <v-icon small>mdi-google-classroom</v-icon>
                    </v-avatar>
                    <span>{{ item.classCount }}</span>
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="saveStudent"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-dialog v-model="showErrorMessageDialog" persistent max-width="320">
      <v-card>
        <v-card-title class="headline"> Already Sold </v-card-title>
        <v-card-text>
          <div class="text-center">
            <div>
              <strong>{{ showErrorMessage }}</strong> if find this is a mistake
              click restock button to sale it
            </div>
            <div class="mt-2">
              <v-btn @click="restock" color="success">Restock</v-btn>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showErrorMessageDialog = false">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </v-card>
</template>

<script>
import productService from "@/modules/Product/service";
// import purchaseService from "@/modules/Inventory/Purchase/service";
import { mapGetters, mapActions } from "vuex";
import studentService from "@/modules/Student/service.js";

export default {
  props: ['customerID'],
  data() {
    return {
      showErrorMessageDialog: false,
      showErrorMessage: null,
      error: [],
      search: null,
      searchProduct: null,
      productSearchLoading: false,
      selectedStudent: null,
      Products: [],
      Students: [],
      loadingNumber: false,
      phoneSearch: null,
      selectedProduct: null,
      selected: [],
      name: null,
      disabledQty: false,
      qty: 1,
      price: 0,
      total: 0,
      dialog: false,
    };
  },
  created() {
    this.emptyEntryBar();
  },
  computed: {
    ...mapGetters("subscription", ["Invoice", "InvoiceDetails", "getSelectedCustomer"]),
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  watch: {
    phoneSearch(val) {
      if (val && val.length === 1) {
        this.getProduct();
      }
      if (val && val.length > 1) this.error = [];
    },
    qty() {
      this.total = this.qty * this.price;
    },
    price(val) {
      this.total = val * this.qty;
    },
    selectedProduct(val) {
      if (val) {
        this.setProduct(val);
      }
    },
    dialog(val) {
      if (val) {
        this.loadingNumber = true;
        this.getStudent();
        // this.getSerialList(this.selectedProduct);
      }
    },
  },
  methods: {
    ...mapActions("subscription", ["AddInvoiceDetail", "UnDeleteInvoiceDetailRow"]),
    ...mapActions("global", ["PlaySound"]),
    getStudent() {
      return studentService.getAll({ CustomerId: this.getSelectedCustomer.id }).then((response) => {
        this.Students = response.data;
        console.log("response Students", this.Students);
        this.loadingNumber = false
        return response;
      });
    },

    closeDialog() {
      this.dialog = false;
      this.emptyEntryBar();
    },
    async getSerialList(product) {
      const list = await purchaseService.getAvailableSerial({
        ProductId: product.id,
      });
      this.serailList = list.data.rows;
      this.loadingNumber = false;
    },
    setProduct(product) {
      if (product) {
        this.price = product.price;
        this.total = product.price * this.qty;
        this.name = product.name;
        if (product.isFee) {
          this.disabledQty = true;
        } else {
          this.disabledQty = false;
        }
        setTimeout(() => {
          this.$refs.itemName.focus();
        }, 300);
        // if (product.imeiNumber) {
        //   setTimeout(() => {
        //     this.$refs.unitPrice.focus();
        //   }, 300);
        //   // this.$nextTick(() => {
        //   //   this.$refs.unitPrice.focus();
        //   // });
        // } else {
        //   setTimeout(() => {
        //     this.$refs.itemName.focus();
        //   }, 300);
        //   // this.$nextTick(() => {
        //   //   this.$refs.itemName.focus();
        //   // });
        // }
      }
    },
    emptyEntryBar() {
      this.name = null;
      this.qty = 1;
      this.total = 0;
      this.price = 0;
      this.phoneSearch = null;
      this.selectedProduct = null;
      this.dialog = false;
      this.Products = [];
      this.selected = [];
      setTimeout(() => {
        this.$refs.productSearch.focus();
      }, 300);
    },
    submit() {
      if (!this.selectedProduct) return false;
      if (this.selectedProduct.isFee) {
        this.dialog = true;
      } else {
        this.selectedProduct.Bar = {
          name: this.name,
          qty: this.qty,
          price: this.price,
        };
        this.$emit("submit", this.selectedProduct);
        this.emptyEntryBar();
      }
    },
    async saveStudent() {
      console.log('selectedStudent', this.selectedStudent)
      this.AddInvoiceDetail({
        ProductId: this.selectedProduct.id,
        name: this.name,
        studentName: this.selectedStudent.fullName,
        price: this.selectedStudent.ClassStudents[0].parentPay,
        total: this.selectedStudent.ClassStudents[0].parentPay * 1,
        StudentId: this.selectedStudent.id,
        ClassId: this.selectedStudent.ClassStudents[0].Class.id,
        // ClassRoomId: this.selectedStudent.ClassRoomStudents[0].ClassRoomId,
        qty: 1,
        cost: 0,
      });

      this.closeDialog();
    },
    getProduct() {
      return productService.getAll().then((result) => {
        console.log("product", result);
        // { trackSerialNumber: false }
        const product = result.data;
        product.map((row) => {
          if (row.trackSerialNumber) {
            if (row.balance > 0) this.Products.push(row);
          } else {
            this.Products.push(row);
          }
        });
      });
    },
  },
};
</script>

<style scoped></style>
